import React, { useEffect, useState } from "react";
import ajaxDepartments from "../../util/remote/ajaxDepartments";
import toast from "react-hot-toast";
const DepartmentsListCard = () => {
  const [departments, setDepartments] = useState([]);
  const fetch_departmentList = async () => {
    try {
      const server_response = await ajaxDepartments.fetchDepartmentsList({});
      if (server_response.status === "OK") {
        setDepartments(server_response.details);
      } else {
        toast.error(server_response.message);
      }
    } catch (err) {
      toast.error("Error fetching departments: " + err.message);
    }
  };
  useEffect(() => {
    fetch_departmentList();
  }, []);
  return (
    <div className="card modern-card mg-b-20 shadow-sm">
      <div className="card-body">
        <div className="mb-3">
          <label className="main-content-label mb-1 fw-bold">
            Organisation Departments
          </label>
          <span className="d-block tx-12 text-muted">
            List of all departments in the organisation
          </span>
        </div>
        {/* Scrollable table wrapper */}
        <div
          className="table-responsive table-wrapper-scroll-y"
          style={{ maxHeight: "330px", minHeight: "330px", overflowY: "auto" }}
        >
          <table className="table modern-table text-nowrap table-hover align-middle mb-0">
            <thead>
              <tr>
                <th></th>
                <th>NO</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(departments) && departments.length > 0 ? (
                departments.map((dept, key) => (
                  <tr key={key}>
                    <td className="wd-5p">
                      <div className="avatar-wrapper icon-wrapper">
                        <i className="fas fa-building fa-lg"></i>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-middle ms-3">
                        <div className="d-inline-block">
                          <h6 className="mb-0">{key + 1}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-middle ms-3">
                        <div className="d-inline-block">
                          <h6 className="mb-0">{dept.department}</h6>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-4 text-muted">
                    <i className="fas fa-inbox fa-2x mb-2"></i>
                    <p>No departments found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* Modern Styles */}
      <style>
        {`
          .modern-card {
            border: none;
            border-radius: 12px;
            background: linear-gradient(145deg, #ffffff, #f4f6f9);
            padding: 1rem;
            transition: transform 0.2s ease-in-out;
          }
          .modern-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          }
          .modern-table thead  {
               background: linear-gradient(135deg, rgba(48, 87, 125, 1)rgba(4, 64, 125, 1)F);
            position: sticky;
            top: 0;
            z-index: 1;
            color: #fff;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .modern-table tbody tr:hover {
            background-color: #e6f0ff;
            cursor: pointer;
          }
          /* Icon wrapper for department */
          .icon-wrapper {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #4169E1;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #6A5ACD;
          }
          @media (max-width: 768px) {
            .icon-wrapper {
              width: 40px;
              height: 40px;
            }
          }
          @media (max-width: 576px) {
            .icon-wrapper {
              width: 35px;
              height: 35px;
            }
          }
        `}
      </style>
    </div>
  );
};
export default DepartmentsListCard;
